
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.9 13.9c0-.3 0-.5-.1-.7C21.4 8.9 18.7 5 14 5c-4.8 0-8 4.3-8 8.9 0 4.4 3 8.6 7.6 8.8 4.9.3 7.8-3.7 8.3-8.1 0-.2.1-.4 0-.7z"}})])
          )
        }
      }
    